import { FaReact, FaPython } from 'react-icons/fa';
import { SiCsharp, SiJavascript, SiTypescript } from 'react-icons/si';
import { IoMdCodeWorking } from 'react-icons/io';
import { MdOutlinePaid } from 'react-icons/md';
import icindproj from '../images/icindustriesproj.png';
import SafeNotes from '../images/SafeNotes.png';
import ImgRevise from '../images/ImageReviser.png';
import SysResMonitor from '../images/SystemResMonitor.png';

const featuredProjects = [
  {
    title: 'Career Chronicles',
    description:
      'This is a Northern Michigan University wide website that is going to be used for all students on campus. This is in partnership with Dr. Kow as well as the Career Services Department.',
    frameworks: [FaReact, SiTypescript],
    type: 'Paid Project',
    typeIcon: <MdOutlinePaid />
  },
  {
    title: 'IC Industries',
    image: icindproj,
    description:
      'This is a website I created for a game composer and game developer studio called IC Industries. They specialize in creating unique 2D RPGs using RPG Maker.',
    link: 'https://icindustriesdev.pages.dev/',
    frameworks: [FaReact, SiJavascript],
    type: 'Paid Project',
    typeIcon: <MdOutlinePaid />
  },
  {
    title: 'SafeNotes',
    image: SafeNotes,
    description:
      'SafeNotes is a secure and easy-to-use notes application made in C# designed to keep your thoughts and information safe. With features like password verification, journaling, notepad functionalities, and dark mode, SafeNotes offers a comprehensive solution for organizing your notes securely.',
    link: 'https://github.com/Thymester/SafeNotes',
    github: 'https://github.com/Thymester/SafeNotes',
    frameworks: [SiCsharp],
    type: 'Skill Building Project',
    typeIcon: <IoMdCodeWorking />
  },
  {
    title: 'Image Revise',
    image: ImgRevise,
    description:
      'ImageRevise is a simple Tkinter-based application for resizing and optimizing images. It allows users to add watermarks, resize images while maintaining aspect ratio, and optimize them for web use. Additionally, it provides functionality to view and remove EXIF metadata from images.',
    link: 'https://github.com/Thymester/ImageRevise',
    github: 'https://github.com/Thymester/ImageRevise',
    frameworks: [FaPython],
    type: 'Skill Building Project',
    typeIcon: <IoMdCodeWorking />
  },
  {
    title: 'System Resource Monitor',
    image: SysResMonitor,
    description:
      'The System Resource Monitor is a Python application built using the Tkinter GUI toolkit. It provides real-time monitoring of CPU and memory usage on a computer system. The application allows users to set thresholds for CPU and memory usage, and it sends notifications when these thresholds are exceeded.',
    link: 'https://github.com/Thymester/System-Resource-Monitor',
    github: 'https://github.com/Thymester/System-Resource-Monitor',
    frameworks: [FaPython],
    type: 'Skill Building Project',
    typeIcon: <IoMdCodeWorking />
  }
];

export default featuredProjects;
